import { type ReactNode, useEffect } from 'react';
import { useSegment } from '@repo/poly-hooks/segment';
import { Success } from 'receivable-invoices-js/react/components/sdd-payment-link';
import { Error } from 'receivable-invoices-js/react/components/mandates';
import { Loading } from 'receivable-invoices-js/react/components/shared/loading';
import { createTrackingProperties } from 'receivable-invoices-js/react/utils/mandates';
import { useRouteQuery } from './use-route-query';
import styles from './layout.module.css';

export function MandatesSuccessRoute(): ReactNode {
  const segment = useSegment();
  const { errorType, isError, isLoading, mandate, refetch } = useRouteQuery();

  useEffect(() => {
    if (mandate) {
      const getTrackingProperties = createTrackingProperties({
        isSddRecurring: mandate.isSddRecurring,
        addressWasPrefilled: mandate.addressWasPrefilled,
        scheduleType: mandate.sddScheduleType,
        scheduleTotalCollectionCount: mandate.sddScheduleCount,
      });
      const trackingProperties = getTrackingProperties(true);
      segment.track('public-page-sdd_authorize-payment_successful', trackingProperties);
    }
  }, [segment, mandate]);

  if (isLoading) {
    return <Loading spinnerSize="large" />;
  }

  if (isError && errorType) {
    return (
      <div className={styles.fullScreenPage}>
        <Error
          errorType={errorType}
          onRetry={errorType === 'generic_error' ? () => refetch() : undefined}
        />
      </div>
    );
  }

  return (
    <div className={styles.fullScreenPage}>
      <Success />
    </div>
  );
}
